<template>
    <div>
        <f-title :title="$t('contract.termsOfCancelation') "  />
        <v-row class="no-frame"  >
            <v-col class="no-frame col-4 pr-2" v-show="monthsNeeded">
                <f-read-only-field
                    class  = "w-100 mt-1"
                    :dense = "true"
                    :label = "$t('contract.toc.months')"
                    :value = "contract.tocMonths"
                    color  = "pt-0-5 pl-1 ro-background"
                />
            </v-col>
            <v-col class="no-frame" :class="monthsNeeded ? 'pl-2' : ''">
                <f-read-only-field
                    class  = "w-100 mt-1"
                    :dense = "true"
                    :label = "$t('contract.toc.until')"
                    :value = "contract.tocType ? contract.tocType.name : null"
                    color  = "pt-0-5 pl-1 ro-background"
                />
            </v-col>
        </v-row>
        <v-row class="no-frame"  >
            <v-textarea
                class          = "pt-0 ro-background"
                v-model        = "contract.tocComment"
                rows           = "3"
                :readonly      = "true"
                autocomplete   = "off"
                autocorrect    = "off"
                autocapitalize = "off"
                spellcheck     = "false"
                no-resize
                hide-details
            />
        </v-row>
        <v-row class="no-frame"  >
            <v-col class="no-frame col-6">
                <v-checkbox
                    v-model   = "contract.tocRewal"
                    :label    = "$t('contract.toc.renewal.automatic')"
                    :ripple   = "false"
                    :readonly = "true"
                    style     = "margin-top:16px"
                    hide-details
                />
            </v-col>
            <v-col class="no-frame col-2 pr-2">
                <f-read-only-field
                    v-show="contract.tocRewal"
                    class  = "w-100 mt-1"
                    :dense = "true"
                    :label = "$t('contract.toc.renewal.duration')"
                    :value = "contract.tocRenewalDuration"
                    color  = "pt-0-5 pl-1 ro-background"
                />
            </v-col>
            <v-col class="no-frame pl-2">
                <f-read-only-field
                    v-show="contract.tocRewal"
                    class  = "w-100 mt-1"
                    :dense = "true"
                    :label = "$t('contract.toc.renewal.period')"
                    :value = "contract.renewalType ? contract.renewalType.name : null"
                    color  = "pt-0-5 pl-1 ro-background"
                />
            </v-col>
        </v-row>

    </div>
</template>

<script>

import Core        from "@/modules/core/service/Core";
import Contract    from "@/modules/msd/company/contract/service/Contract";
import FTitle      from "@/modules/core/components/utils/FTitle";
import FReadOnlyField from "@/modules/core/components/utils/FReadOnlyField.vue";

export default {
    name: "PSiteContractToc",

    components: {
        FReadOnlyField,
        FTitle,
    },

    props: {
        contract: {
            required: true,
            type    : Object,
            default : function () {
                return {
                    tocType           : null,
                    tocMonths         : null,
                    tocRewal          : null,
                    tocComment        : null,
                    tocRenewalDuration: null,
                    renewalType       : null
                }
            },
        },
    },

    computed: {
        monthsNeeded () {
            if (!this.contract.tocType) {
                return true;
            }

            return this.contract.tocType.id !== Contract.enums.toc.mounths
                && this.contract.tocType.id !== Contract.enums.toc.fix
                && this.contract.tocType.id !== Contract.enums.toc.special
   //             && this.contract.tocType.id !== Contract.enums.toc.contractend;
        },

        requiredRule() {
            return Core.rule.required;
        },
    },

    methods: {
        monthRule (value) {
            if (!this.monthsNeeded) {
                return true;
            }

            if (!value || value.length === 0) {
                return this.$t("rules.required");
            }

            if (this.contract.tocType) {
                switch (this.contract.tocType.id) {
                    case Contract.enums.toc.quarters:
                        if (value < 1 || value > 3) {
                            return this.$t('contract.toc.max3');
                        }
                        break;
                    case Contract.enums.toc.halfyears:
                        if (value < 1 || value > 6) {
                            return this.$t('contract.toc.max6');
                        }
                        break;
                    case Contract.enums.toc.years:
                        if (value < 1 || value > 12) {
                            return this.$t('contract.toc.max12');
                        }
                        break;
                }
            }

            return true;
        },

        tocTypeRule (value) {
            if (!value) {
                return this.$t("rules.required");
            }

            if (this.contract.tocMonths > 0 && !value) {
                return this.$t("rules.required");
            }

            return true;
        },

        renewalRule (value) {
            if (!this.contract.tocRewal) {
                return true;
            }

            if (!value || value.length === 0) {
                return this.$t("rules.required");
            }

            if (value < 1) {
                return this.$t('contract.toc.renewal.error');
            }

            return true;
        },

        renewalTypeRule (value) {
            if (!this.contract.tocRewal) {
                return true;
            }

            if (!value) {
                return this.$t("rules.required");
            }

            return true;
        },
    }
}
</script>

<style scoped>
::v-deep .v-input__control textarea {
    border-width: unset !important;
    border-color: unset !important;
    border-style: unset!important;
}

</style>